const menuViewMap = {
    '1-1.vue+threejs 初始Demo': () => import('../views/1-1initDemo'),
    '1-2.着色器 顶点着色器-轨道控制器': () => import('../views/1-2vertextShader'),
    '1-3.着色器 顶点着色器-涟漪-双屏': () => import('../views/1-3vertextShaderHalfScreen'),
    '1-4.控制器-拖拽控制器': () => import('../views/1-4DragControls'),
    '1-5.控制器-第一人称控制器': () => import('../views/1-5FirstPersonControls'),
    '1-6.控制器-轨迹球控制器': () => import('../views/1-6TrackballControls'),
    '1-7.控制器-变换控制器': () => import('../views/1-7TransformControls'),
    '1-8.原始几何体': () => import('../views/1-8Geometries'),
    '1-9.动态拉伸': () => import('../views/1-9ExtrudeGeometry'),
    '1-10.粒子系统': () => import('../views/1-10particleSystem'),
    '1-11.粒子系统-改变': () => import('../views/1-11particleSystem-Change'),
    '1-12.字体改变': () => import('../views/1-12particleSystem-raining'),
    '1-13.火焰': () => import('../views/1-13fire'),
    '1-14.3D标签和跨图层展示': () => import('../views/1-14label'),
    '1-15.透视和正交相机机混合渲染': () => import('../views/1-15Perspect_Orthographic'),
    '1-16.透视和正交相机机混合渲染2': () => import('../views/1-16Perspect_Orthographic2'),
    '1-17.字体路径运动': () => import('../views/1-17letter_path'),
    '1-18.后期处理': () => import('../views/1-18letter_path_camera'),
    '1-19.报警灯': () => import('../views/1-19warningLight'),
    'test1': () => import('../views/test1'),
    'test2': () => import('../views/test2'),
    'test3': () => import('../views/test3')
};
  
export default menuViewMap;